__turbopack_context__.v({
  "contentContainer": "DesignSection-module__ghWtta__contentContainer",
  "imageWrapper": "DesignSection-module__ghWtta__imageWrapper",
  "ringImage": "DesignSection-module__ghWtta__ringImage",
  "section": "DesignSection-module__ghWtta__section",
  "textContainer": "DesignSection-module__ghWtta__textContainer" + " " + __turbopack_context__.i(515534)["sectionTextBlock"],
});
